<div class="ticket-header" id="print-section">
    <h4 translate>Multiple tickets selected</h4>
    <div class="d-flex flex-row align-items-center flex-wrap mt-4">
        <app-category-selector-bulk class="me-2" [tickets]="selectedTickets"></app-category-selector-bulk>
        <app-tags [tags]="tags"></app-tags>
        <span
            class="label label-tags label-sm pointer"
            (click)="openAddTagsModal()"
            [ngClass]="{ disabled: isUpdating }">
            <sb-inline-svg
                class="icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Tag icon.svg'"></sb-inline-svg>
            {{ 'Tags' | translate }}
        </span>
    </div>
    <div class="flex-row d-flex justify-content-between flex-wrap mt-2" id="ticket-short-header">
        <app-assign-block
            (assignTicket)="assign($event)"
            [isAssigned]="isAssigned"
            [usersForAssign]="usersForAssign"
            [isBulkOperation]="true"
            [assignee]="assignee"
            class="mb-2"></app-assign-block>

        <span class="flex-grow-1"></span>
        <button
            class="btn btn-icon me-3"
            (click)="linkTickets()"
            [disabled]="isUpdating"
            placement="bottom"
            [tooltip]="'Link tickets' | translate">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon.svg'"></sb-inline-svg>
        </button>

        <div class="btn-group btn-group-sm">
            <button
                type="button"
                class="btn"
                [ngClass]="{
                    'btn-default': status !== ticketStatusEnum.open,
                    'btn-active': status === ticketStatusEnum.open,
                }"
                (click)="updateStatus(ticketStatusEnum.open)"
                [disabled]="isUpdating"
                translate>
                Open
            </button>
            <button
                type="button"
                class="btn"
                [ngClass]="{
                    'btn-default': status !== ticketStatusEnum.pending,
                    'btn-active': status === ticketStatusEnum.pending,
                }"
                (click)="updateStatus(ticketStatusEnum.pending)"
                [disabled]="isUpdating"
                translate>
                Pending
            </button>
            <button
                type="button"
                class="btn"
                [ngClass]="{
                    'btn-default': status !== ticketStatusEnum.completed,
                    'btn-active': status === ticketStatusEnum.completed,
                }"
                (click)="updateStatus(ticketStatusEnum.completed)"
                [disabled]="isUpdating"
                translate>
                Closed
            </button>
        </div>
    </div>
</div>
<div class="ticket-block text-end">
    <form [ngClass]="{ submitted: isSubmitted }">
        <textarea
            [formControl]="newReplyText"
            placeholder="{{ 'Write a reply' | translate }}"
            class="form-control mb-2"
            name="newReplyTest"
            maxlength="20000"
            sbTrim
            required></textarea>
        <button (click)="addReply()" [disabled]="isUpdating" class="btn btn-outline" translate>send</button>
    </form>
</div>
